<template>
      <b-field grouped>
        <b-field label="Jinete" label-position="inside" expanded>
          <b-autocomplete
              v-model="rider"
              placeholder="Selecciona un Jinete"
              :open-on-focus="true"
              :data="filterRiders"
              field="name"
              @select="option => selectedRider = option" :loading="isLoadingRiders"
              :custom-formatter="fullName">
              <template slot-scope="props">
                {{props.option.lastname}} {{props.option.name}}
              </template>
          </b-autocomplete>
        </b-field>
        <b-field label="Caballo" label-position="inside" expanded grouped>
          <b-autocomplete
              v-model="horse"
              placeholder="Selecciona un Caballo"
              :open-on-focus="true"
              :data="filterHorses"
              field="name"
              @select="option => selectedHorse = option" :loading="isLoadingHorses" expanded>
               <template slot-scope="props">
                    <div class="media">
                        <div class="media-content">
                            <b>{{ props.option.name }}</b>
                            <br>
                            <small v-if="props.option.rider" style="color: #f44336;">
                                Asignado a {{ props.option.rider.lastname }} {{ props.option.rider.name }}
                            </small>
                            <small v-else style="color: #4CAF50;">
                                No asignado
                            </small>
                        </div>
                    </div>
                </template>
          </b-autocomplete>
        </b-field>
        <b-field label="Fecha asignación" label-position="inside" expanded>
          <b-datepicker
            v-model="start_date"
            :first-day-of-week="1"
            :month-names="$moment.months()"
            :day-names="$moment.weekdaysShort()"
            :show-week-number="true"
            placeholder="Click para seleccionar"
            icon="calendar-today"
            position="is-bottom-left"
          >
          </b-datepicker>
        </b-field>
        <p class="control" style="padding-left: 0.5rem">
          <b-button class="button is-primary" @click="confirmAssignments" :disabled="disabledSaveButton" :loading="isLoadingSave">Asignar</b-button>
        </p>
      </b-field>
</template>

<script>
import HorseService from '@/services/HorseService'
import RiderService from '@/services/RiderService'
const Diacritics = require('diacritic')

export default {
  components: {
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    this.getHorses()
    this.getRiders()
  },
  data () {
    return {
      isLoading: false,
      rider: '',
      horse: '',
      start_date: null,
      selectedHorse: null,
      selectedRider: null,
      horses: [],
      riders: [],
      isLoadingSave: false,
      isLoadingHorses: false,
      isLoadingRiders: false
    }
  },
  methods: {
    async getHorses () {
      this.isLoadingHorses = true
      let params = {
        'include[0]': 'rider',
        'active': true
      }
      let response = await HorseService.getHorses(params)
      this.horses = response.data.data
      this.isLoadingHorses = false
    },
    async getRiders () {
      this.isLoadingRiders = true
      let params = {
        'user_status_id': 1
      }
      let response = await RiderService.getRiders(params)
      this.riders = response.data.data
      this.isLoadingRiders = false
    },
    success () {
      this.$buefy.toast.open({
        message: 'Caballo asignado correctamente',
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo asignar el caballo',
        type: 'is-danger'
      })
    },
    confirmAssignments () {
      if (this.selectedHorse.rider) {
        let riderName = `${this.selectedHorse.rider.lastname} ${this.selectedHorse.rider.name}`
        this.$buefy.dialog.confirm({
          title: 'Reemplazando asignación',
          message: `¿Está seguro que desea <b>reemplazar</b> la asignación existente? <br> Este caballo se encuentra asignado a ${riderName}`,
          confirmText: 'Confirmar Asignación',
          cancelText: 'Cancelar',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.assign()
        })
      } else {
        this.assign()
      }
    },
    async assign () {
      this.isLoadingSave = true
      let data = {
        'rider_id': this.selectedRider.id,
        'start_date': this.start_date
      }
      try {
        let response = await HorseService.updateHorse(this.selectedHorse.id, data)
        this.isLoadingSave = false
        this.clearData()
        if (response && response.status === 200) {
          this.success()
          this.$emit('reload-data', true)
          this.getHorses()
        } else {
          this.error()
        }
      } catch (error) {
        console.log(error)
        this.isLoadingSave = false
        this.error()
      }
    },
    clearData () {
      this.selectedHorse = null
      this.horse = ''
      this.start_date = null
    },
    fullName (object) {
      return `${object.lastname} ${object.name}`
    }
  },
  watch: {
    selectedRider () {
      this.$emit('rider-selected', this.selectedRider)
    }
  },
  computed: {
    filterHorses () {
      let fixedHorses = Array.from(this.horses)
      fixedHorses.forEach((horse) => {
        horse.fixed = Diacritics.clean(horse.name)
      })

      return fixedHorses.filter((horse) => {
        if (this.selectedRider !== null) {
          return horse.rider_id !== this.selectedRider.id && horse.fixed
            .toString()
            .toLowerCase()
            .indexOf(Diacritics.clean(this.horse.toLowerCase())) >= 0
        } else {
          return horse.fixed
            .toString()
            .toLowerCase()
            .indexOf(Diacritics.clean(this.horse.toLowerCase())) >= 0
        }
      })
    },
    filterRiders () {
      let fixedData = Array.from(this.riders)
      fixedData.forEach((item) => {
        item.fixed = Diacritics.clean(`${item.lastname} ${item.name}`)
      })

      return fixedData.filter((rider) => {
        return rider.fixed
          .toString()
          .toLowerCase()
          .indexOf(Diacritics.clean(this.rider.toLowerCase())) >= 0
      })
    },
    disabledSaveButton () {
      if (!this.selectedHorse || !this.selectedRider) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
